module.exports = Object.freeze({
    modalSong: {
        MAX_LENGTH_REVENUE: 11,
    }
});